<template>
  <v-container fluid v-if="!loaded">
    <v-row align-center justify-center row fill-height>
      <v-col>
      <v-progress-circular
          indeterminate
          :size="70"
          color="primary"
        ></v-progress-circular>
      </v-col>
    </v-row>
  </v-container>
  <div v-else>
    <div class="wrapper" v-if="appointment && appointment.publicId">
      <div class="content">
        <h1>{{messages.appointmentTitle}}</h1>
        <v-container fluid grid-list-md class="info-text">
          <div class="confirmation-text">{{messages.appointmentText}}</div>
          <div class="confirmation-row" v-if="appointment.externalId">
            <div class="confirmation-label">{{messages.commonBookingNumberText}}:</div>
            <div class="confirmation-info">{{appointment.externalId}}</div>
          </div>
          <div  class="confirmation-row">
            <div class="confirmation-label"><span v-if="services.length > 1">{{messages.commonMultipleServicesText}}</span><span v-else>{{messages.commonServiceText}}</span>:</div>
            <div class="confirmation-info">
              <div v-for="(service, index) in services" :key="index">
                {{ servicesTranslations[service.publicId] && servicesTranslations[service.publicId].names[selectedLanguage.lang] ? servicesTranslations[service.publicId].names[selectedLanguage.lang] : service.name }}
                <div v-if="configuration.multiplePeopleEnabled && (service.adult || service.child)" class="confirmation-service-adult">
                  (<span v-if="service.adult">{{service.adult}} <span v-if="service.adult == 1">{{messages.commonAdultText}}</span><span v-else>{{messages.commonAdultsText}}</span></span>
                  <span v-if="service.adult && service.child">, </span>
                  <span v-if="service.child">{{service.child}} <span v-if="service.child == 1">{{messages.commonChildText}}</span><span v-else>{{messages.commonChildrenText}}</span></span>)
                </div>
              </div>
            </div>
         </div>
         <div class="confirmation-row">
            <div class="confirmation-label">{{messages.commonLocationText}}:</div>
            <div class="confirmation-info">{{appointment.branch.custom && appointment.branch.custom.names && appointment.branch.custom.names[selectedLanguage.lang] ? appointment.branch.custom.names[selectedLanguage.lang] : appointment.branch.name }}</div>
          </div>
          <div class="confirmation-row">
            <div class="confirmation-label">{{messages.commonDateAndTimeText}}:</div>
            <div class="confirmation-info">{{appointment.date | formatDate(selectedLanguage)}} {{appointment.time | formatTime(selectedLanguage)}}</div>
          </div>
          <div class="confirmation-row" v-if="appointment.customer.email">
            <div class="confirmation-label">{{messages.Email}}:</div>
            <div class="confirmation-info">{{appointment.customer.email}}</div>
          </div>
          <div class="confirmation-row" v-if="appointment.customer.phone">
            <div class="confirmation-label">{{messages.Phone}}:</div>
            <div class="confirmation-info">+{{appointment.customer.phone}}</div>
          </div>
          <div class="confirmation-row" v-if="checkShowPrices">
            <div class="confirmation-label">{{messages.totalCost}}:</div>
            <div class="confirmation-info">{{appointment.totalCost}} {{messages.chooseServiceContentCurrency}}</div>
          </div>
          <img :src="qrCodeUrl" alt="Qr code" role="presentation" v-if="configuration.showQR">
        </v-container>
      <v-container fluid grid-list-md class="info-text primary-color">
          <h2>{{appointment.branch.custom && appointment.branch.custom.names && appointment.branch.custom.names[selectedLanguage.lang] ? appointment.branch.custom.names[selectedLanguage.lang] : appointment.branch.name }}</h2>
           <div class="confirmation-row" v-if="appointment.branch.phone">
              <div class="confirmation-label">{{messages.branchPhoneTitle}}</div>
              <div class="confirmation-info">{{appointment.branch.phone}}</div>
          </div>
          <div class="confirmation-row" v-if="appointment.branch.email">
              <div class="confirmation-label">{{messages.branchEmailTitle}}:</div>
              <div class="confirmation-info">{{appointment.branch.email}}</div>
          </div>
          <div class="confirmation-row" v-if="showAddress">
            <div class="confirmation-label">{{messages.branchAddressTitle}}:</div>
            <div class="confirmation-info" v-html="branchAddress"></div>
          </div>

        </v-container>
        <div v-if="$route.name === 'appointment'">
          <v-container fluid grid-list-md>
            <v-row column align-center justify-center>
              <v-col d-flex class="action-text">{{messages.appointmentActionsText}}</v-col>
            </v-row>
            <v-row column align-center justify-center>
              <v-col d-block class="action-button">
                <v-btn
                  :ripple="false"
                  text
                  class="submit edit"
                  @click="rescheduleAppointment"
                  id="rescheduleButton"
                  ref="rescheduleButtonRef"
                >{{messages.rescheduleActionButtonText}}</v-btn>
                <p class="screen-reader-only" id="ariaRescheduleTxt">{{messages.commonBookingNumberText}}: {{appointment.externalId}}. {{messages.rescheduleActionButtonText}}</p>
              </v-col>
            </v-row>
            <v-row column align-center justify-center>
              <v-col d-block class="action-button">
                <v-btn
                  :ripple="false"
                  text
                  class="submit cancel"
                  @click="showConfirmDialog = true"
                  id="cancelButton"
                  ref="cancelButtonRef"
                >{{messages.cancelAppointmentActionButtonText}}</v-btn>
                <p class="screen-reader-only" id="ariaCancelTxt">{{messages.commonBookingNumberText}}: {{appointment.externalId}}. {{messages.cancelAppointmentActionButtonText}}</p>
              </v-col>
            </v-row>
          </v-container>
        </div>
         <modal-dialog
            :dialog="showConfirmDialog"
            :dialogMessage="messages.cancelAppointmentConfirmationText"
            :dialogTitle="messages.cancelAppointmentHeader"
            :dialogButtonText="messages.cancelAppointmentAbortButtonText"
            :dialogButtonConfirmText="messages.cancelAppointmentConfirmButtonText"
            @confirmmodal="cancelAppointment"
            @closemodal="showConfirmDialog = false">
          </modal-dialog>
      </div>
    </div>
    <div v-else>
      <div class="content">
        <div class="wrapper">
          <div class="info-text error-message">{{message}}
            <v-btn v-if="messages.startPageNotFoundButtonText"
            class="submit back"
            :ripple="false"
            text
            @click="backToStart"
            id="backToStartButton"
            ref="backToStartRef"
          >{{messages.startPageNotFoundButtonText}}</v-btn>
          <p class="screen-reader-only" id="ariaCancelText">{{messages.cancelledAppointmentText}}. {{messages.backToFindPageButtonText}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import RestService from '../services/restService'
import QRCode from 'qrcode'
import { mapState, mapMutations } from 'vuex'
import { eventHub } from '../utils/eventhub'
import FormatService from '../services/formatService'
import ModalDialog from '../components/Modal'
import moment from 'moment-timezone'

export default {
  name: 'Appointment',
  mixins: [RestService, FormatService],
  components: { ModalDialog },
  data: () => ({
    appointment: {},
    services: [],
    messageElement: '',
    qrCodeUrl: null,
    loaded: false,
    showAddress: false,
    branchAddress: '',
    showConfirmDialog: false
  }),
  computed: {
    ...mapState([
      'configuration',
      'messages',
      'selectedLanguage',
      'servicesTranslations'
    ]),
    checkShowPrices () {
      return this.configuration.pricesEnabled && this.configuration.showPrices
    },
    message () {
      return this.messageElement ? this.messages[this.messageElement] : ''
    }
  },
  watch: {
    selectedLanguage () {
      this.checkShowBranchAddress()
    }
  },
  methods: {
    ...mapMutations([
      'setServicesTranslations'
    ]),
    backToStart () {
      var url = this.messages.startPageNotFoundUrl ? this.messages.startPageNotFoundUrl : ''
      if (url) {
        location.replace(url)
      } else {
        let routingObj = {
          name: 'search'
        }
        eventHub.$emit('reload-configuration', routingObj)
      }
    },
    checkShowBranchAddress () {
      if (this.appointment) {
        this.branchAddress = this.getBranchAddress(this.appointment.branch, 'branchFullAddress')
        if (this.branchAddress.length > 0) { this.showAddress = true } else { this.showAddress = false }
      }
      return this.branchAddress
    },
    rescheduleAppointment () {
      var _this = this
      this.$router.push({
        name: 'reschedule',
        params: {
          configuration: _this.configuration,
          // messages: _this.messages,
          appointment: _this.appointment // ,
          // selectedLanguage: _this.selectedLanguage
        }
      })
    },
    cancelAppointment () {
      var _this = this
      this.deleteAppointment(this.appointment.publicId).then(response => {
        _this.$emit('deleted-appointment', true)
        this.appointment = false
        this.messageElement = 'cancelledAppointmentText'
        this.showConfirmDialog = false
        this.setfocus()
      })
    },
    /* appointmentDeleted (deleted) {
      if (deleted) {
        this.appointment = false
        this.message = this.messages.cancelledAppointmentText
      }
    }, */
    // Set focus to first interactive element
    setfocus (data) {
      this.$nextTick(() => {
        if (this.$route.name === 'appointment') {
          // add reschedule label text
          if (this.appointment) {
            var ariaRescheduleTxt = document.getElementById('ariaRescheduleTxt').innerHTML
            this.$refs.rescheduleButtonRef.$el.ariaLabel = ariaRescheduleTxt
            // add cancel label text
            var ariaCancelTxt = document.getElementById('ariaCancelTxt').innerHTML
            this.$refs.cancelButtonRef.$el.ariaLabel = ariaCancelTxt

            // set focus
            this.$refs.rescheduleButtonRef.$el.focus()
          } else {
            var ariaText = document.getElementById('ariaCancelText').innerHTML
            this.$refs.backToStartRef.$el.ariaLabel = ariaText
            this.$refs.backToStartRef.$el.focus()
          }
        }
      })
    }
  },
  mounted () {
    var _this = this
    var appointmentId = this.$route.params.appointmentId
    this.getAppointment(appointmentId)
      .then(response => {
        var appointment = response.data
        if (appointment) {
          var today = new Date()
          today = moment.tz(moment(), appointment.branch.timeZone)
          var appointmentTime = moment.tz(appointment.date + ' ' + appointment.time, appointment.branch.timeZone)
          if (appointment.status && (appointment.status !== 0 && appointment.status !== 20 && appointment.status !== 21)) {
            _this.appointment = false
            _this.messageElement = 'appointmentAlreadyArrived'
          } else {
            if (today > appointmentTime) {
              _this.appointment = false
              _this.messageElement = 'appointmentNotFound'
            } else {
              _this.appointment = appointment
              if (_this.configuration.showQR) {
                if (_this.configuration.qrType === 'qrQwebbookId' && _this.appointment.externalId) {
                  QRCode.toDataURL(_this.appointment.externalId).then(url => {
                    _this.qrCodeUrl = url
                  })
                } else if (_this.configuration.qrType === 'qrConciergeId' && _this.appointment.qrConciergeId) {
                  QRCode.toDataURL(_this.appointment.qrConciergeId).then(url => {
                    _this.qrCodeUrl = url
                  })
                }
              }
              if (appointment.languageCode) {
                _this.$emit('change-language', appointment.languageCode)
              }
              if (appointment.peopleServices.length > 0 && appointment.peopleServices[0].name) {
                _this.services = appointment.peopleServices
              } else {
                _this.services = appointment.services
              }
              var tempServicesTranslations = {}
              // Query all services to get the translatinos
              this.getServices().then(response => {
                if (this.funcDebug) console.log('Appointment:mounted:getServices.then')
                var allServices = response.data
                this.services.forEach(appService => {
                  if (!appService.customLength || appService.customLength === 0) {
                    allServices.forEach(service => {
                      if (parseInt(appService.qpId) === parseInt(service.qpId) || appService.internalId === parseInt(service.qpId)) {
                        appService.customLength = service.duration
                        tempServicesTranslations[service.publicId] = {}
                        if (service.custom) {
                          service.custom = JSON.parse(service.custom)
                          tempServicesTranslations[service.publicId].names = service.custom.names
                        } else {
                          tempServicesTranslations[service.publicId].names = {}
                        }
                      }
                    })
                  }
                })
                this.setServicesTranslations(tempServicesTranslations)
              })
            }
            if (this.appointment && (typeof appointment.branch.custom !== 'undefined' && appointment.branch.custom !== '')) {
              var customString = appointment.branch.custom
              var customObj = JSON.parse(customString)
              appointment.branch.custom = customObj
              this.checkShowBranchAddress()
            }
          }
        } else {
          _this.appointment = false
          _this.messageElement = 'appointmentNotFound'
        }
        this.loaded = true
      }).then(response => {
        _this.setfocus()
      }).catch(error => {
        _this.appointment = false
        _this.messageElement = 'appointmentNotFound'
        _this.loaded = true
        console.log('Error: ' + error)
      })
  },
  created () {
    // Event Bus: receive route name to set focus to first interactive element
    eventHub.$on('focusFirstEvent', (payload) => { this.setfocus(payload) })
  }
}
</script>

<style>
.info-text.appointment-details.actions {
  border-top: 1px solid;
  border-color: var(--primary-border-color) !important;
}

.action-text {
  font-weight: 400;
  font-size: 23px;
  text-align: center;
  margin: auto;
}

.action-button {
  width: 100%;
}

.confirmation-label{
  font-weight: bolder;
  width: 30%;
  float: left;
}
.confirmation-info{
  float: left;
  width: 70%;
}
.confirmation-row{
  overflow: auto;
}

.submit.edit.v-btn.v-btn--text.theme--light,
.submit.cancel.v-btn.v-btn--text.theme--light {
  display: block;
  margin: 0 auto;
  min-width: 400px;
}

@media (max-width: 600px) {
  .submit.edit.v-btn.v-btn--text.theme--light,
  .submit.cancel.v-btn.v-btn--text.theme--light {
    min-width: 100%;
  }

  .action-text {
    font-size: 18px;
  }

  .phoneErrorMessage {
    margin-left: 0px;
  }
}
</style>
